<template>
  <div>
      <vs-card actionable class="cardx">
        <div slot="header">
          <h3>
            Location
          </h3>
        </div>





        <vs-row>
 <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="6">
   <img class="size-icon" src="../../../assets/images/NewLocation/IconLocation.png" alt="">

</vs-col>


 <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
 <vs-row>
   
<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
  <h3 class="font-total">Total</h3>
  
</vs-col>
<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
<h3>4</h3>
</vs-col>

   </vs-row>
 
</vs-col>
          </vs-row>
        <div slot="footer">
          <vs-row vs-justify="flex-end">
            <vs-button color="primary" type="gradient" >View Location</vs-button>
          </vs-row>
        </div>
      </vs-card>
  </div>
</template>

<script>
export default {
    name: 'NumLocation'
}
</script>

<style>

.size-icon {
  width: 60px;
}




.font-total {
  font-weight: bold;
}
</style>